<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>素材管理 > <b>贴纸列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
            <span class="search_span_width">
                <span class="search_span_width_part1">分类：</span>
				<Select v-model="search.material_type" style="width:260px">
					<Option v-for="item in tiezhi_type" :value="item.id" :key="item.id">{{ item.name }}</Option>
				</Select>
            </span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="gettiezhiList()">搜索</Button>
      </Card>
      <Card>
       <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addTiezhiModal()">添加贴纸</Button>
			</span>
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="tiezhi_list"></Table>
		  <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="gettiezhiList"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="贴纸">
        <Form ref="tiezhi" :model="tiezhi" :label-width="80" :rules="tiezhiRule" >
			<FormItem label="排序" prop="seq">
				 <InputNumber v-model="tiezhi.seq" :min="0" />
			</FormItem>
			<FormItem label="名称" prop="title">
				 <Input v-model="tiezhi.title"  />
			</FormItem>
			<FormItem label="分类" prop="material_type">
				<Select v-model="tiezhi.material_type" style="width:260px">
					<Option v-for="item in tiezhi_type" :value="item.id" :key="item.id">{{ item.name }}</Option>
				</Select>
			</FormItem>
			<FormItem label="素材" prop="cover">
			    <Upload action="1" :before-upload="handleUpload" >
					<div>{{file_name}}</div>
			    <Button icon="ios-cloud-upload-outline" >请先选择素材</Button>
				<Progress :percent="upLoadProgress" v-show="upLoadProgress_show" />
			    </Upload>
			</FormItem> 
            <FormItem>
                <Button type="primary" @click="updateTiezhi()">提交</Button>
            </FormItem>
        </Form>
    </Modal>
	<Modal v-model="showeditmodal" :footer-hide=true title="贴纸">
	     <Form ref="tiezhi" :model="tiezhi" :label-width="80" :rules="tiezhiRule" >
				<FormItem label="排序" prop="seq">
					 <InputNumber v-model="tiezhi.seq" :min="0" />
				</FormItem>
				<FormItem label="名称" prop="title">
					 <Input v-model="tiezhi.title"  />
				</FormItem>
         <FormItem label="英文名称" prop="en_title">
           <Input v-model="tiezhi.en_title"  />
         </FormItem>
				<FormItem label="分类" prop="material_type">
					<Select v-model="tiezhi.material_type" style="width:260px">
						<Option v-for="item in tiezhi_type" :value="item.id" :key="item.id">{{ item.name }}</Option>
					</Select>
				</FormItem>
	         <FormItem>
	             <Button type="primary" @click="editTiezhi()">提交</Button>
	         </FormItem>
	     </Form>
	 </Modal>
	
  </Layout>
</template>
<script>

export default {
  data(){
    return {
		search : {
			material_type:0
		},
		showmodal:false,
		showeditmodal:false,
		recordTotal:0,
		page:1,
		tiezhi_type:[],
		tiezhi_list:[],
		file_name:'',
		tiezhi:{
			id:0,
			title:'',
      en_title:'',
			cover:0,
			url:0,
			seq:0,
			size:0,
			file:'',
			material_type:0
		},
		upLoadProgress:0,
		upLoadProgress_show:false,
		tiezhiRule :{
			title:[
			   { required: true, message: "请输入素材标题", trigger: "blur" },
			],
			url: [
				{ required: true, message: '请上传素材', trigger: 'blur' }
			],
			material_type:[
				{ required: true, message: '请选择分类', trigger: 'blur' }
			]
		},
		tableColumns:[
		{ title: '素材ID', key: 'id', align: 'center' },
		{ title: '名称', key: 'title', align: 'center' },
      { title: '英文名称', key: 'en_title', align: 'center' },
		{ title: '分类', key: 'material_type_name', align: 'center'},
		{ title: '封面', key: 'cover', align: 'center',
		render:(h,params) =>{
		   return h('img',{
			 attrs : {
				src : params.row.cover
			 },
			 style : {
			   width : '80px',
			   height : '80px'
			 }
		   })
		}},
		{ title: '素材', key: 'url', align: 'center',
		 render:(h,params) =>{
			 if (params.row.type == 6) {
				 return h('span',{
				 	domProps: {
				 		innerHTML: '<video controls="controls" style="width:150px;height:150px;"><source src="'+params.row.url+'" type="audio/mpeg" /></video>'
				 	}
				 })
			 } else if (params.row.type == 5) {
				 return h('img',{
					 attrs : {
						src : params.row.url
					 },
					 style : {
					   width : '80px',
					   height : '80px'
					 }
				 })
			 } else {
				 return h('span','');
			 }

		 }},
		{ title: '排序', key: 'seq', align: 'center' },
		{ title: '操作', key: 'action', align: 'center',
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {   
						this.tiezhi.id = params.row.id;
						this.tiezhi.seq = parseInt(params.row.seq);
						this.tiezhi.title = params.row.title;
            this.tiezhi.en_title = params.row.en_title;
						this.tiezhi.material_type = parseInt(params.row.material_type);
						this.showeditmodal = true;
					}
				  }
				}, '编辑'),
			);
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {   
						this.delTieZhi(params.row.id);
					}
				  }
				}, '删除'),
			);
			return h("div",btns);
		  }
		}
		],
		uploadHeader:{
		  "Authorization":localStorage.getItem('token')
		},
	}
  },
  mounted:function(){
	this.gettiezhiList();
	this.gettiezhiType();
  },
  computed:{
	  getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/material/upload';
	  }
  },
  methods:{
	delTieZhi(id){
		var config = {
			content: '确认删除？删除可能会影响到已使用此贴纸的用户',
			onOk: () => {
				this.http.post('/admin/material/delTieZhi',{id:id}).then(response=>{
				  let data=response.data;
				  if(data.code!==0){
					this.$Message.error(data.message);
				  } else{
					this.gettiezhiList(this.page);
				  }
				}).catch(()=>{
				  this.$Message.error('网络错误');
				});
			}
		}
		this.$Modal.warning(config)
	},
	addTiezhiModal(){
		this.tiezhi.id = 0;
		this.tiezhi.title = '';
    this.tiezhi.en_title = '';
		this.tiezhi.cover = '';
		this.tiezhi.seq = 0;
		this.tiezhi.url = '';
		this.tiezhi.file = '';
		this.file_name = '';
		this.tiezhi.material_type = 0;
		this.upLoadProgress_show = false;
		this.upLoadProgress = 0;
		this.showmodal = true;
	},
	handleUpload (file) {
		this.tiezhi.file = file;
		this.file_name = file.name;
		return false;
	},
	gettiezhiType() {
		this.http.get('/admin/material/tiezhiType').then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.tiezhi_type = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	gettiezhiList(page=1) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/material/tiezhi',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.tiezhi_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	updateTiezhi(){
		let self = this;
		let config = {
			headers: {
				'Content-Type': 'multipart/form-data',
				"Authorization":localStorage.getItem('token')
			},
			onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
				if (progressEvent.lengthComputable) {
					//属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
					//如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
				  self.upLoadProgress= parseInt(progressEvent.loaded / progressEvent.total * 100)  //实时获取上传进度
				}
			}
		};
		if (!this.tiezhi.file) {
			this.$Message.error('请先选择上传文件');
			return false;
		}
		if (!this.tiezhi.material_type) {
			this.$Message.error('请先选择分类');
			return false;
		}
		if (!this.tiezhi.title) {
			this.$Message.error('请填写贴纸标题');
			return false;
		}
		//以formData形式上传
		var param = new FormData();
		param.append('file',this.tiezhi.file);
		param.append('title',this.tiezhi.title);
		param.append('material_type',this.tiezhi.material_type);
		param.append('seq',this.tiezhi.seq);
		let url = process.env.VUE_APP_APIHOST + '/admin/material/uploadMaterial';
		console.log(url);
		this.upLoadProgress_show = true;
		this.$axios.post(url, param, config).then((response) => {
			let data = response.data;
			console.log(data);
			if(data.code!=0){
				this.$Message.error(data.message);
				return true;
			}
			this.$Message.info("上传成功");
			this.showmodal = false;
			this.gettiezhiList(this.page);
		})
	},
	editTiezhi(){
		  this.http.post('/admin/material/editTiezhi',this.tiezhi).then(response=>{
		    let data=response.data;
		    if(data.code!==0) {
		      this.$Message.error(data.message);
		      return false;
		    } else{
		      this.$Message.info(data.message);
		      this.showeditmodal = false;
				this.gettiezhiList(this.page);
		      return true;
		    }
		  });
	}
  }
}
</script>